import { Component, EventEmitter, Output } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'instrument-details-push-alert-modal',
  templateUrl: './push-alert-modal.component.html',
  styleUrls: ['./push-alert-modal.component.scss'],
  imports: [TranslocoPipe],
})
export class PushAlertModalComponent {
  @Output() public handleClose = new EventEmitter<void>();
}
